import { InjectionToken } from '@angular/core';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Configuration } from '@azure/msal-browser';

export interface Settings {
  baseUrl: string;
  environment: 'local' | 'dev' | 'test' | 'uat' | 'prod';
  isProd: boolean;

  msal: {
    config: Configuration;
    guard: MsalGuardConfiguration;
    interceptor: MsalInterceptorConfiguration;
  };

  appInsightsConnectionString: string;
}

export const SETTINGS = new InjectionToken<Settings>('SETTINGS');
